
export default {
  name: "es_p295",
  props: ["categoryCms"],
  data() {
    return {
    smartbuys: [],
      ready: false,
      tab: 0,
      cms: { subtitle: "", header_media: "" },
      sub_categories: [],
      bestSellers: [],
      newProducts: [],
      discounts: [],
      pathCache: "",
      agora: [],
      agoraBanners: [],
      showAgoraTop:false,
      chips: []
    };
  },
  computed: {
    // #22057 — exact-match per-listing SEO doc for this path (or undefined)
    seo() {
      return (this.$store.getters.cms.listing_page_seo || []).find(
        (d) => d && d.match_url === this.$route.path
      );
    },
  },
  async created() {
   
    try {
      if(!this.showItems() && !this.$store.getters.filters.business_activity){
      this.$nuxt.context.error({
        status: 404,
        message: 'Not found',
      })
    }
      if (this.pathCache != this.$route.fullPath) {
        this.pathCache = this.$route.fullPath;
        this.categoryData();
      }
    } catch (error) {}
    if (!this.showItems()) {
      try {
        this.getData();
      } catch (e) {}
    }
  },
  watch: {
    "$route.fullPath": function (v) {
      if (v.includes("catalog") && !v.includes("product")) {
        if (v != this.pathCache) {
          this.cms = { subtitle: "", header_media: "" };
          this.categoryData();
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 200);
    if (process.browser && this.showItems() && this.$store.getters.items) {
      this.reportAgoraImpressions(this.$store.getters.items);
    }
    this.$nuxt.$on("newItems", (_) => {
      this.reportAgoraImpressions(_);
    });
    if(process.browser){
    try {
      this.$cms.get({ title: "listing_page_pills", store_id: this.$store.getters.store.id, match_url: this.$route.path, limit: 200 }).then(() => {
        this.chips = (this.$store.getters.cms.listing_page_pills || []).filter(c=>c.match_url === this.$route.path).sort((a,b)=>a.position - b.position);
      });
    } catch (e) {
      console.error(e);
    }
    try {
        this.smartbuys = this.$store.getters.store.eshop.rules
          ?.filter(
            (r) =>
            r &&
              (r.variables || []).includes("smartbuy") &&
              !r.disabled &&
              r.conditions.some((c) => c.type == "items" || c.type == "key") &&
              r.filters?.business_activities?.includes(
                this.$store.getters.filters.business_activity
              )
          );
        console.log(this.smartbuys);
      } catch (error) {
        console.error(error);
      }
    setTimeout(()=>{
      try{
      let builderBanner = document.querySelector(`[data-shopster_id="builderBanner"]`);
      console.log(builderBanner?.checkVisibility());
      if(builderBanner?.checkVisibility()){
        this.showAgoraTop = false;
      }else{
        this.showAgoraTop = true;
      }
    }catch(e){}
    },300)
    }
  },
  methods: {
    reportAgora(id) {
      if (process.browser) {
        window.citrusAd.reportClick(id);
      }
    },
    reportAgoraImpressions(items) {
      if (process.browser) {
        items.forEach((i) => {
          if (i.adId) {
            if (localStorage.getItem("debug")) {
              console.log(i.adId);
            }
            try{
              window.citrusAd.reportImpression(i.adId);
            }catch(e){}
            console.log(i.adId);
          }
        });
      }
    },
    async getData(e) {
      
      let bestSellers = await this.$hyperRemote.getData({
        e: {
          uid: "bestSellers",
          sorting: "orderby=sales&order=desc",
          params: [
            {
              value: this.$store.getters.filters.business_activity,
              build: this.$store.getters.filters.business_activity,
              key: "business_activity",
            },
          ],
        },
        cookies: this.$cookies,
        app: this,
        urlOnly: true,
      });
      let newProducts = await this.$hyperRemote.getData({
        e: {
          uid: "newProducts",
          sorting: "orderby=created_at&order=desc",
          params: [
            {
              value: this.$store.getters.filters.business_activity,
              build: this.$store.getters.filters.business_activity,
              key: "business_activity",
            },
          ],
        },
        cookies: this.$cookies,
        app: this,
        urlOnly: true,
      });
      let discounts = await this.$hyperRemote.getData({
        e: {
          uid: "discounts",
          sorting: "orderby=prices.discount&order=desc",
          params: [
            {
              value: this.$store.getters.filters.business_activity,
              build: this.$store.getters.filters.business_activity,
              key: "business_activity",
            },
          ],
        },
        cookies: this.$cookies,
        app: this,
        urlOnly: true,
      });

      let bulk = await this.$axios.$post(
        `${process.env.axiosUrl}/utilities/bulk`,
        {
          requests: [bestSellers, newProducts, discounts],
        }
      );
      for (const b of bulk) {
        try {
          if (b.uid == "bestSellers")
            this.bestSellers = await this.$hyperItem.prepareItems(
              b.result.items.docs
            );
          if (b.uid == "newProducts")
            this.newProducts = await this.$hyperItem.prepareItems(
              b.result.items.docs
            );
          if (b.uid == "discounts")
            this.discounts = await this.$hyperItem.prepareItems(
              b.result.items.docs
            );
        } catch (error) {
          console.warn(error);
        }
      }
    },
    async categoryData() {
      if (
        !this.$store.getters.filters.price &&
        !this.$store.getters.filters.manufacturer &&
        !Object.keys(this.$store.getters.filters).some((x) => x.includes("tag"))
      ) {
        let taxonomy = this.$store.getters.filters.business_activity;
        if (this.$store.getters.filters.family) {
          taxonomy += `>${this.$store.getters.filters.family}`;
        }
        if (this.$store.getters.filters.subfamily) {
          taxonomy += `>${this.$store.getters.filters.subfamily}`;
        }
        let agora = await this.$axios.$get(
          `${process.env.axiosUrl}/utilities/agora?store_id=${this.$store.getters.store.id}&type=catalogue&limit=8&forElement=true&taxonomy=${taxonomy}`
        );
        this.agora = await this.$hyperItem.prepareItems(agora.items.docs);
        if (this.agora.length < 8) {
          try {
            let extraAgora = await this.$axios.$get(
              `${process.env.axiosUrl}/utilities/agora?store_id=${this.$store.getters.store.id}&type=catalogue&limit=8&forElement=true`
            );
            this.agora = [
              ...this.agora,
              ...(await this.$hyperItem.prepareItems(extraAgora.items.docs)),
            ];
          } catch (e) {}
        }
        let agoraBanners = await this.$axios.$get(
          `${process.env.axiosUrl}/utilities/agora?store_id=${this.$store.getters.store.id}&banner=true&type=catalogue&limit=8&taxonomy=${taxonomy}`
        );
        this.agoraBanners = agoraBanners;
        this.agoraBanners.forEach(b=>{
          if (b.id) {
            if (localStorage.getItem("debug")) {
              console.log(b.id);
            }
            try{
              window.citrusAd.reportImpression(b.id);
            }catch(e){}
            console.log(b.id);
          }
        })
      } else {
        this.agoraBanners = [];
        this.agora = [];
      }
      if (
        (this.pathCache == this.$route.fullPath && this.cms?.subtitle) ||
        this.$route.fullPath.includes("product")
      ) {
        return;
      }
      this.pathCache = this.$route.fullPath;
      let fCms = this.$store.getters.cms.categories || [];
      try {
        let fromCms = fCms.find(
          (f) =>
            f.business_activity ==
              this.$store.getters.filters.business_activity &&
            (f.family || "") == (this.$store.getters.filters.family || "") &&
            (f.subfamily || "") ==
              (this.$store.getters.filters.subfamily || "") &&
            (f.manufacturer || "") ==
              (this.$store.getters.filters.manufacturer || "") &&
            (f["tag__anagki"] || "") ==
              (this.$store.getters.filterLabels[
                this.$store.getters.filters["tag.anagki"]
              ] ||
                this.$store.getters.filters["tag.anagki"] ||
                "")
        );
        if (fromCms) {
          fromCms.header_media = this.$hyperUtility.eshopIcon(
            "business_activity",
            false,
            this.$store.getters.filters.business_activity,
            false,
            "header_media",
            1000
          );
          fromCms.header_media_mobile = this.$hyperUtility.eshopIcon(
            "business_activity",
            false,
            this.$store.getters.filters.business_activity,
            false,
            "header_media_mobile",
            768
          );
          this.cms = fromCms;
        } else {
          this.cms = { subtitle: "", header_media: "" };
        }
      } catch (error) {
        console.error(error);
        this.cms = { subtitle: "", header_media: "" };
      }
      if (Array.isArray(this.$store.getters.catalogue)) {
        this.sub_categories = this.$store.getters.catalogue
          ?.find((c) => c.key == "family")
          ?.family?.map((f) => {
            f.media = this.$hyperUtility.eshopIcon(
              "family",
              false,
              f.key,
              false,
              "page",
              400
            );
            return f;
          });
      }
    },
    showItems() {
      if ((Object.keys(this.$route.query) || []).length || !this.$route.params.path) {
        return true;
      }
      return (
        (Object.keys(this.$store.getters.params) || []).filter(
          (x) => this.$store.getters.params[x]
        ).length > 1 ||
        (Object.keys(this.$store.getters.params) || [])[0] !=
          "business_activity"
      );
    },
    updateTitle() {
      this.$emit("updateTitle", "Αναζήτηση");
    },
  },
};
